import { Api } from '../api/Api.js'

export function apiGetDataStoreOrder() {
  return Api('get', '/card/get_data_store_order')
}


export function apiStoreNewOrder(body) {
  return Api('post', '/card/store_new_order',{ body })
}
